import Header from "./components/Header";
import Hero from "./components/Hero";
import EntranceBoard from "./components/EntranceBoard";
import FlashTimeline from "./components/FlashTimeline";
import CollectionBoard from "./components/CollectionBoard";
import TopicGrid from "./components/TopicGrid";
import GuideFaq from "./components/GuideFaq";
import Footer from "./components/Footer";

export default function Home() {
  return (
    <div className="min-h-screen bg-[#fbf7f0] font-sans text-stone-900">
      <Header />
      <main>
        <Hero />
        <EntranceBoard />
        <FlashTimeline />
        <CollectionBoard />
        <TopicGrid />
        <GuideFaq />
      </main>
      <Footer />
    </div>
  );
}